import React from "react";
import { markdownToHtml } from "../../utils/markdown";
import "./MarkdownPreview.css";

const MarkdownPreview = ({
  content = "",
  className = "",
  emptyText = "No content.",
}) => {
  const hasContent = Boolean(`${content || ""}`.trim());

  if (!hasContent) {
    return <div className={`markdown-preview markdown-preview-empty ${className}`.trim()}>{emptyText}</div>;
  }

  return (
    <div
      className={`markdown-preview ${className}`.trim()}
      dangerouslySetInnerHTML={{ __html: markdownToHtml(content) }}
    />
  );
};

export default MarkdownPreview;
